import React, { Component } from 'react';
import Header from '../../layout/header/header'
import Footer from '../../layout/footer/footer'
import blogBnr from '../../assets/blog-bnr.png'
import blogimg11 from '../../assets/blog-img11.png'
import img222 from '../../assets/img222.png'

import '../blogs-inr/blogsInr.css';

class blogsInr extends Component {
  render() {
    return (
      <div>
        <Header/>
        {/* <!-- blog banner start --> */}
    <section className="blog_inr_bnr">
        <div className="container-fluid">
            <img className="img-fluid" src={blogBnr} alt="img" />
        </div>
    </section>
    {/* <!-- blog banner end -->

    <!-- blog_content_full --> */}
    <div className="blog_content_full">
        <div className="container-fluid">
            <h2>The lorem ipsum gets its name from the Latin phrase Neque porro</h2>
            <div className="row align-items-center">
                <div className="col-md-4">
                    <img className="img-fluid" src={blogimg11} alt="img" />
                </div>
                <div className="col-md-8">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. eiusmod tempor incididunt ut labore et dolore magna aliqua. labore et dolore mikm ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, psum dolor sit amet, consectetur adipiscing elit,</p>
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-md-8">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. eiusmod tempor incididunt ut labore et dolore magna aliqua. labore et dolore mikm ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, psum dolor sit amet, consectetur adipiscing elit,</p>
                </div>
                <div className="col-md-4">
                    <img className="img-fluid" src={blogimg11} alt="img" />
                </div>
            </div>
        </div>

    </div>



    {/* <!-- repairing and servicing --> */}
    <section className="banner_sonk inr_page_cont">
      <div className="container-fluid">
        <h3>Recommended for yo</h3>
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="repairing_inr">
                <div className="row align-items-center">
                  <div className="col-lg-4">
                      <div className="blogs_inner">
                          <img className="img-fluid" src={img222} alt="img" />
                      </div>
                  </div>
                  <div className="col-lg-8">
                      <div className="blog_content">
                          <div className="con_top">
                              <h3>The lorem ipsum gets its</h3> 
                          </div>
                          <p>The lorem ipsum gets its name from the Latin phrase Neque porro quisquam est qui dolorem ipsum  </p>
                          <div className="con_botm d-flex justify-content-between">
                            <div><i className="fa fa-repeat" aria-hidden="true"></i> 
                              <i className="fa fa-cloud-download" aria-hidden="true"></i></div> 
                              <div><span>8 : 22 Am </span> <span>2 K Views</span></div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="repairing_inr">
                <div className="row align-items-center">
                  <div className="col-lg-4">
                      <div className="blogs_inner">
                          <img className="img-fluid" src={img222} alt="img" />
                      </div>
                  </div>
                  <div className="col-lg-8">
                      <div className="blog_content">
                          <div className="con_top">
                              <h3>The lorem ipsum gets its</h3> 
                          </div>
                          <p>The lorem ipsum gets its name from the Latin phrase Neque porro quisquam est qui dolorem ipsum  </p>
                          <div className="con_botm d-flex justify-content-between">
                            <div><i className="fa fa-repeat" aria-hidden="true"></i> 
                              <i className="fa fa-cloud-download" aria-hidden="true"></i></div> 
                              <div><span>8 : 22 Am </span> <span>2 K Views</span></div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="repairing_inr">
                <div className="row align-items-center">
                  <div className="col-lg-4">
                      <div className="blogs_inner">
                          <img className="img-fluid" src={img222} alt="img" />
                      </div>
                  </div>
                  <div className="col-lg-8">
                      <div className="blog_content">
                          <div className="con_top">
                              <h3>The lorem ipsum gets its</h3> 
                          </div>
                          <p>The lorem ipsum gets its name from the Latin phrase Neque porro quisquam est qui dolorem ipsum  </p>
                          <div className="con_botm d-flex justify-content-between">
                            <div><i className="fa fa-repeat" aria-hidden="true"></i> 
                              <i className="fa fa-cloud-download" aria-hidden="true"></i></div> 
                              <div><span>8 : 22 Am </span> <span>2 K Views</span></div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </section>
    <Footer/>
      </div>
    );
  }
}

export default blogsInr;
